function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "28",
  height: "28",
  viewBox: "0 0 28 28"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M25.667 0H2.333A2.31 2.31 0 000 2.333v23.334A2.31 2.31 0 002.333 28h23.334A2.31 2.31 0 0028 25.667V2.333A2.31 2.31 0 0025.667 0zM14 27.067v-9.334h-3.733V14H14v-3.267c0-2.66 2.053-4.9 4.667-5.133h4.2v3.733h-3.734c-.793 0-1.4.607-1.4 1.4V14H22.4v3.733h-4.667v9.334H14zm13.067-1.4c0 .793-.607 1.4-1.4 1.4h-7v-8.4h4.666v-5.6h-4.666v-2.334c0-.28.186-.466.466-.466H23.8v-5.6h-5.18c-3.127.28-5.553 2.94-5.553 6.066v2.334H9.333v5.6h3.734v8.4H2.333c-.793 0-1.4-.607-1.4-1.4V2.333c0-.793.607-1.4 1.4-1.4h23.334c.793 0 1.4.607 1.4 1.4v23.334z"
})), /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#9B9B9B",
  fillRule: "evenodd",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#979797",
  strokeWidth: ".5",
  d: "M25.667.25H2.333A2.06 2.06 0 00.25 2.333v23.334a2.06 2.06 0 002.083 2.083h23.334a2.06 2.06 0 002.083-2.083V2.333A2.06 2.06 0 0025.667.25zM13.75 17.983h-3.733V13.75h3.733v-3.017c0-2.782 2.146-5.137 4.917-5.383h4.45v4.233h-3.984c-.655 0-1.15.495-1.15 1.15v3.017h4.667v4.233h-4.667v9.334H13.75v-9.334zm9.333.434v-5.1h-4.666v-2.584a.69.69 0 01.716-.716h4.417v-5.1l-4.908-.001c-2.994.268-5.325 2.817-5.325 5.817v2.584H9.583v5.1h3.734v8.9H2.333c-.931 0-1.65-.719-1.65-1.65V2.333c0-.931.719-1.65 1.65-1.65h23.334c.931 0 1.65.719 1.65 1.65v23.334c0 .931-.719 1.65-1.65 1.65h-7.25v-8.9h4.666z"
}))));